import type { FC, ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import { styles } from '../feature-promotion-banner.styles';
import type {
  FeaturePromotionBannerMediaHideBelow,
  FeaturePromotionBannerMediaPlacement,
} from '../feature-promotion-banner.types';

export interface FeaturePromotionBannerMediaProps {
  children: ReactNode;
  hideBelow?: FeaturePromotionBannerMediaHideBelow;
  rounded?: boolean;
  placement?: FeaturePromotionBannerMediaPlacement;
  className?: string;
  testId?: string;
}

export const FeaturePromotionBannerMedia: FC<FeaturePromotionBannerMediaProps> = ({
  children,
  hideBelow = 'lg',
  rounded = false,
  placement = 'overlay',
  className,
  testId,
}) => {
  const hideClass =
    hideBelow === 'sm'
      ? styles.mediaHideSm
      : hideBelow === 'md'
      ? styles.mediaHideMd
      : hideBelow === 'lg'
      ? styles.mediaHideLg
      : undefined;

  return (
    <div
      className={cx(
        placement === 'overlay' ? styles.mediaOverlay : styles.mediaInline,
        rounded && styles.mediaRounded,
        hideClass,
        className
      )}
      aria-hidden='true'
      data-testid={testId}
    >
      {children}
    </div>
  );
};
